import React from 'react';
import './SMI.scss';
import './SMI-media.scss';
import CardSMIReview from '../CardSMIReview/CardSMIReview';
import { Props } from './interfaces';

const SMI = ({ list }: Props) => {
  return (
    <div className="smi">
      <h2 className="smi__title">Оцените Dalli</h2>

      <div className="smi__list">
        {list.map((item, i) => (
          <div className={`smi__${i + 1}`} key={i}>
            <CardSMIReview {...item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SMI;
